import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';
import { CommonUiComponentsTextInputComponent } from './common-ui-components-text-input/common-ui-components-text-input.component';
import { CommonUiComponentsTextInputAutosizeDirective } from './common-ui-components-text-input/common-ui-components-text-input-autosize.directive';

@NgModule({
  imports: [CommonModule, FormsModule, MaterialLibraryModule, CdwIconModule],
  declarations: [
    CommonUiComponentsTextInputComponent,
    CommonUiComponentsTextInputAutosizeDirective,
  ],
  exports: [
    CommonUiComponentsTextInputComponent,
    CommonUiComponentsTextInputAutosizeDirective,
  ],
})
export class CommonUiComponentsTextInputModule {}
